// Story 8.6 (ADO-2015), D-8 — the Submit card on the Order Review page (Figma desktop 4976:1731,
// mobile 4393:12517): the heading "Submit order", what is being sent, and the green primary
// "Submit order" button. The send itself is `useOrderSubmissionStore`'s.
//
// The subtitle is "Send the {cart} cart." rather than the frame's "Send the Ambient cart to
// EUROSPAR Bunclody - 05484.": the client has no source for the store's name before the send
// (OQ-4). The cart is the page's name for it: the depot's ("Ambient"), or at an entry that names
// its account the depot's and the account's ("VC Dublin · Main grocery"; Story 8.4, ADO-2013).
// The confirmation names the account from the server's answer.
//
// The button is `aria-disabled` (still focusable, so a screen reader hears why) while an attempt is
// in flight ("Submitting…"), while a line edit is settling, a previous order is being added or the
// cart is being cleared, and while the active basket is not open: the cart the Shopper reviewed is
// the cart that is sent. That predicate and the send are `useSubmitOrder`'s, shared with the Order
// footer's button (Story 8.14), so the page's two Submit buttons always agree.
//
// A failed send's message is `SubmitOrderFailure`, mounted by the page beside this card rather
// than inside it, so it is still shown when the card is hidden (an empty cart).

import { Button } from '../../design-system';
import { useSubmitOrder } from '../../basket/useSubmitOrder';
import styles from './SubmitOrderCard.module.css';

export interface SubmitOrderCardProps {
  readonly depotId: string;
  /** The cart's name; undefined while the depot's name is unresolved. */
  readonly cartName: string | undefined;
}

export function SubmitOrderCard({ depotId, cartName }: SubmitOrderCardProps) {
  const { send, blocked, sending } = useSubmitOrder(depotId);

  return (
    <section className={styles.card} aria-labelledby="submit-order-heading">
      <div className={styles.row}>
        <div className={styles.text}>
          <h2 id="submit-order-heading" className={styles.heading}>
            Submit order
          </h2>
          <p className={styles.subtitle}>
            {cartName !== undefined && cartName !== ''
              ? `Send the ${cartName} cart.`
              : 'Send this cart.'}
          </p>
        </div>
        <Button
          variant="primary"
          className={styles.button}
          data-testid="order-submit-button"
          aria-disabled={blocked ? 'true' : undefined}
          onClick={send}
        >
          {sending ? 'Submitting…' : 'Submit order'}
        </Button>
      </div>
    </section>
  );
}
